import { BaseService } from './BaseService';
import type { AgentContextWindowConfigDto, UpdateContextWindowConfigRequest } from '../types/contextWindow';

/**
 * Service for context window configuration operations.
 */
export class ContextWindowConfigService extends BaseService {
  /**
   * Gets the context window configuration for an agent definition.
   */
  async getConfig(agentDefinitionId: string): Promise<AgentContextWindowConfigDto> {
    return this.get<AgentContextWindowConfigDto>(`/context-window-configs/${agentDefinitionId}`);
  }

  /**
   * Updates (or creates) the context window configuration for an agent definition.
   */
  async updateConfig(
    agentDefinitionId: string,
    data: UpdateContextWindowConfigRequest
  ): Promise<AgentContextWindowConfigDto> {
    return this.put<AgentContextWindowConfigDto>(`/context-window-configs/${agentDefinitionId}`, data);
  }
}

export const contextWindowConfigService = new ContextWindowConfigService();

